import prettyMS from "pretty-ms";

const FileUploadProgress = ({
    progress = 0,
    remaining = 0,
  }) => {
    return (
        <>
        {!!progress && (
            <div class="progress mt-2" style={{display: `${progress==100 ? 'none' : 'block'}`}} >
                <div class="progress-bar bg-success" role="progressbar" aria-label="Example with label" style={{width: `${progress}%`, display: `${progress==100 ? 'none' : 'block'}`}} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">{progress}% </div>
            </div>
        )}        

         {!!remaining && (
            <div className="mb-1.5 text-sm text-gray-700">
              Remaining time: {prettyMS(remaining)}
            </div>
          )}         

      {/* <div className="py-1.5 h-6 relative">
        <div className="absolute top-0 bottom-0 left-0 w-full h-full bg-gray-400"></div>
        <div
          style={{width: `${progress}%`,}}
          className="absolute top-0 bottom-0 left-0 h-full transition-all duration-150 bg-gray-600"
        ></div>
        <div className="absolute top-0 bottom-0 left-0 flex items-center justify-center w-full h-full">
          <span className="text-xs font-bold text-white">{progress}%</span>
        </div>
      </div> */}

      </>
    );
  };
  
  export default FileUploadProgress;